// @flow
import type { SessionsContext } from "components/ResourceFill/types/sessions-context";
import * as React from "react";
import type { Session } from "types/session";
import type { SessionObject as SessionMap } from "types/session-object";

type Props = {
  children: React.Node,
  sessions: SessionMap,
  sessionId: string,
  setSessions: (sessions: SessionMap) => void,
};

export const ResourceSessionsContext: React.Context<?SessionsContext> =
  React.createContext(null);

function ResourceSessionsProvider({
  children,
  sessions,
  sessionId,
  setSessions,
}: Props): React.Node {
  const [currentSession, setCurrentSession] = React.useState<null | Session>(
    sessions?.[sessionId],
  );
  const value = React.useMemo(
    () => ({
      sessions,
      sessionId,
      currentSession,
      setCurrentSession,
      setSessions,
    }),
    [currentSession, sessionId, sessions, setSessions],
  );

  return (
    <ResourceSessionsContext.Provider value={value}>
      {children}
    </ResourceSessionsContext.Provider>
  );
}

export default ResourceSessionsProvider;
